import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { EasyEnvironment } from '@easy-lib/modules/shared/models/environment';

@Injectable({
	providedIn: 'root'
})
export class VersionService {
	readonly key: string = 'build_no';
	currentBuildNumber: string;
	constructor(
		private storage: LocalStorageService,
		environment: EasyEnvironment
	) {
		this.currentBuildNumber = environment.build;
	}

	isNewVersion(): any {
		const oldBuildNo = this.storage.getItem(this.key);
		return this.currentBuildNumber != oldBuildNo;
	}

	setCurrentVersion() {
		this.storage.setItem(this.key, this.currentBuildNumber);
	}
}
